// extracted by mini-css-extract-plugin
export default {"menuOrderedList":"Xywdb__menuOrderedList","menuListItem":"WKY6S__menuListItem"};